const modalDefaultState = {
  openModalImportSheet: false, // open modal import sheet file
  isAIRequestLimitModalVisible: false,
}

export default modalDefaultState
